/*
==================================================
CART MOBILE HEADER

Функция:
верхняя шапка мобильной модалки cart / checkout

Родитель:
index.tsx

Дочерние элементы:
ShippingPriceNudge

Использует:
пока без visual config / animation config / controller

Примечания:
содержит только:
- заголовок CART / CHECKOUT
- кнопку закрытия
- баннер free shipping
==================================================
*/

import { StoreCart, StoreCartShippingOption } from "@medusajs/types"
import ShippingPriceNudge from "@modules/shipping/components/free-shipping-price-nudge"
import { triggerHaptic } from "../../../../lib/custom-ui/haptics/haptics"

type CartMobileHeaderProps = {
  modalTitle: string
  cart?: any
  shippingOptions?: any[]
  onClose: () => void
}

export default function CartMobileHeader({
  modalTitle,
  cart,
  shippingOptions = [],
  onClose,
}: CartMobileHeaderProps) {
  return (
    <div className="relative z-10 shrink-0 border-b border-black/10 px-0 py-1">
      <div className="flex w-full items-center justify-between px-4 pb-1 pt-1">
        <div className="min-w-0">
          <div className="text-[1.3rem] font-black uppercase tracking-[0.18em] text-white">
            {modalTitle}
          </div>
        </div>

        <button
          type="button"
          onClick={() => {
            triggerHaptic(10)
            onClose()
          }}
          className="flex h-6 w-6 items-center justify-center rounded-full border border-white/20 bg-gradient-to-b from-white/20 to-white/10 text-white/90 shadow-inner backdrop-blur-sm transition-all active:scale-95"
        >
          <span className="mb-0.5 text-[1rem] leading-none">×</span>
        </button>
      </div>

      {shippingOptions.length > 0 && cart?.items?.length > 0 && (
        <div className="mt-1 px-1">
          <ShippingPriceNudge
            variant="inline"
            cart={cart as StoreCart}
            shippingOptions={shippingOptions as StoreCartShippingOption[]}
          />
        </div>
      )}
    </div>
  )
}
